<app-page-header title="Floor Plans"></app-page-header>
<nexus-grid [data]="floor_plans_model">
    <kendo-grid-column field="name" title="Name"></kendo-grid-column>
    <kendo-grid-column field="bedrooms" title="Bedrooms"></kendo-grid-column>
    <kendo-grid-column field="bathrooms" title="Bathrooms"></kendo-grid-column>
    <kendo-grid-column field="square_feet" title="Square Feet"></kendo-grid-column>

</nexus-grid>
